// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5 = /** @type {(inputs: { toUnit: NonNullable<unknown>, fromUnit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The default sales unit of this product is ${i?.toUnit}, but the order is in ${i?.fromUnit}. An automatic conversion will be applied upon submission.`)
};

const en_us2_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5 = /** @type {(inputs: { toUnit: NonNullable<unknown>, fromUnit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The default sales unit of this product is ${i?.toUnit}, but the order is in ${i?.fromUnit}. An automatic conversion will be applied upon submission.`)
};

const de_de2_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5 = /** @type {(inputs: { toUnit: NonNullable<unknown>, fromUnit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Standard-Verkaufseinheit dieses Produkts ist ${i?.toUnit}, aber die Bestellung erfolgt in ${i?.fromUnit}. Bei der Übermittlung wird eine automatische Umrechnung vorgenommen.`)
};

const en_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5 = /** @type {(inputs: { toUnit: NonNullable<unknown>, fromUnit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The default sales unit of this product is ${i?.toUnit}, but the order is in ${i?.fromUnit}. An automatic conversion will be applied upon submission.`)
};

const de_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5 = /** @type {(inputs: { toUnit: NonNullable<unknown>, fromUnit: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Standard-Verkaufseinheit dieses Produkts ist ${i?.toUnit}, aber die Bestellung erfolgt in ${i?.fromUnit}. Bei der Übermittlung wird eine automatische Umrechnung vorgenommen.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ toUnit: NonNullable<unknown>, fromUnit: NonNullable<unknown> }} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5", locale)
	if (locale === "en-GB") return en_gb2_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5(inputs)
	if (locale === "en-US") return en_us2_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5(inputs)
	if (locale === "de-DE") return de_de2_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5(inputs)
	if (locale === "en") return en_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5(inputs)
	return de_assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5(inputs)
};
export { assistantsalesorder_positions_koestnerwarnings_unitconversionapplied5 as "assistantSalesOrder.positions.koestnerWarnings.unitConversionApplied" }